import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

import { FDBodyText, FDStack } from '@facet-wealth/design';


export default function AchTransferLayout() {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'}>
      <MetaControlField attr="fullLiquidation" />
      <MetaControlField attr="amount" />
      <MetaControlField attr="frequency" />
      <MetaControlField attr="startDate" />
      <MetaControlField attr="endByDate" />
      <MetaControlField attr="iraDistributionReason" />
      <MetaControlField attr="iraContributionType" />
      <MetaControlField attr="iraContributionApplyToPriorYear" />

      {resource.attr('acknowledgementOfTaxInformation') !== undefined && (
        <FDBodyText size={'md'} value={'Tax Withholding Details'} />
      )}
      <MetaControlField attr="acknowledgementOfTaxInformation" />
      <MetaControlField attr="withholdFederalTaxes" />
      <MetaControlField attr="federalTaxWithholdingPercentage" />
      <MetaControlField attr="withholdStateTaxes" />
      <MetaControlField attr="stateTaxWithholdingPercentage" />

    </FDStack>
  );
}
